import { SortEvent } from 'primeng/api';

export function globalSortFunction<T>(event: SortEvent, numericFields: (keyof T)[]): void {
  const field = event.field as keyof T;
  const order = event.order;

  if (event.data && field && order) {
    event.data.sort((a: T, b: T) => {
      const value1 = a[field];
      const value2 = b[field];

      // If the field is numeric but has a prefix
      if (numericFields.includes(field)) {
        const num1 = extractNumericSuffix(value1);
        const num2 = extractNumericSuffix(value2);
        if (num1 !== null && num2 !== null) {
          return (num1 - num2) * order;
        }
      }

      // Sort as string if not numeric
      const strValue1 = value1 == null ? '' : value1.toString();
      const strValue2 = value2 == null ? '' : value2.toString();
      return strValue1.localeCompare(strValue2) * order;
    });
  }
}

function extractNumericSuffix(value: unknown): number | null {
  if (typeof value === 'string') {
    const match = value.match(/(\d+)$/);
    if (match) {
      return Number(match[1]);
    }
  } else if (typeof value === 'number') {
    return value;
  }
  return null;
}

export function sortByPrefixAndNumber<T>(event: SortEvent, field: keyof T): void {
  const order = event.order;
  if (event.data && field && order) {
    event.data.sort((a: T, b: T) => {
      const { prefix: prefixA, number: numberA } = splitPrefixAndNumber(a[field]);
      const { prefix: prefixB, number: numberB } = splitPrefixAndNumber(b[field]);

      // Compare prefix first
      const prefixCompare = prefixA.localeCompare(prefixB);
      if (prefixCompare !== 0) {
        return prefixCompare * order;
      }
      // If prefix is the same, compare number
      return (numberA - numberB) * order;
    });
  }
}

function splitPrefixAndNumber(value: unknown): {
  prefix: string;
  number: number;
} {
  if (typeof value === 'string') {
    const match = value.match(/^(.*?)(\d+)$/);
    if (match) {
      return {
        prefix: match[1],
        number: Number(match[2]),
      };
    }

    return { prefix: value, number: 0 };
  } else if (typeof value === 'number') {
    return { prefix: '', number: value };
  }

  return { prefix: '', number: 0 };
}
